import React from 'react';
import {
  Container,
  StoreContainer,
  StoreRow,
  Title,
  Text,
  ChannelWhatsapp,
  WhatsappInfo,
  InfoChannel,
  ListItem,
  LinkContainer,
  FooterContainer,
  FooterColumn,
  LineSeparatorTop,
  LineSeparatorBot,
  AllRightsReserved
} from './styled';
import IconOutlook from '../../../assets/icons/IconOutlook.svg';
import IconOffice from '../../../assets/icons/IconOffice.svg';
import IconPhone from '../../../assets/icons/IconPhone.svg';
import IconWhatsapp from '../../../assets/icons/IconWhatsapp.svg';
import IconGooglePlay from '../../../assets/icons/IconGooglePlay.svg';
import IconAppStore from '../../../assets/icons/IconAppStore.svg';
import IconAppGallery from '../../../assets/icons/IconAppGallery.svg';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const getNameForAnalytics = (testid: any) => {
  switch (testid) {
    case 'cmp-outlook-button':
      return 'PlatformsOutlook';
    case 'cmp-office-button':
      return 'PlatformsMicrosoft';
    default:
      return '';
  }
};

const handlerRedirectNewPage = (url: any, e?: any) => {
  const testId = e?.currentTarget.dataset.testid;
  const nameAnalitics = getNameForAnalytics(testId);
  GoogleAnalytics.writeLog(`portal-home-click${nameAnalitics}`, 'home');
  window.open(url, '_blank');
};

const FooterView = () => (
  <Container data-testid="cmp-footer-view">
    <LineSeparatorTop />
    <FooterContainer className="grid grid-cols-2 lg3:grid-cols-3 gap-xlg">
      <div className="col-span-2 sm:col-span-1">
        <Title>Encuéntra UTP+app en estas tiendas</Title>
        <StoreRow>
          <StoreContainer
            data-testid="cmp-google-play-button"
            onClick={() =>
              handlerRedirectNewPage(
                'https://play.google.com/store/apps/details?id=com.inlearning&hl=es&gl=US'
              )
            }
            formTarget="_blank"
            type="button"
          >
            <img src={IconGooglePlay} alt="IconGooglePlay" />
            <p>Google Play</p>
          </StoreContainer>
          <StoreContainer
            data-testid="cmp-app-store-button"
            onClick={() =>
              handlerRedirectNewPage(
                'https://apps.apple.com/pe/app/utp/id1488014558'
              )
            }
            formTarget="_blank"
            type="button"
          >
            <img src={IconAppStore} alt="IconAppStore" />
            <p className="space-right">App Store</p>
          </StoreContainer>
        </StoreRow>
        <div>
          <StoreContainer
            data-testid="cmp-app-gallery-button"
            onClick={() =>
              handlerRedirectNewPage(
                'https://appgallery.huawei.com/#/app/C103466585'
              )
            }
            formTarget="_blank"
            type="button"
            style={{ marginTop: '20px' }}
          >
            <img src={IconAppGallery} alt="IconAppGallery" />
            <p>AppGallery</p>
          </StoreContainer>
        </div>
      </div>
      <FooterColumn className="col-span-2 sm:col-span-1">
        <Title>Otras plataformas</Title>
        <ul>
          <ListItem>
            <img src={IconOutlook} alt="IconOutlook" width="26" height="26" />
            <LinkContainer
              data-testid="cmp-outlook-button"
              onClick={(e) =>
                handlerRedirectNewPage('https://outlook.office.com/', e)
              }
              formTarget="_blank"
              type="button"
            >
              <Text>Correo outlook</Text>
            </LinkContainer>
          </ListItem>
          {/*
          <ListItem>
            <img src={IconCanvas} alt="IconCanvas" width="26" height="26" />
            <LinkContainer
              data-testid="cmp-canvas-button"
              onClick={() =>
                handlerRedirectNewPage('https://canvas.utp.edu.pe/login/canvas')
              }
              formTarget="_blank"
              type="button"
            >
              <Text>Canvas</Text>
            </LinkContainer>
          </ListItem>
            */}
          <ListItem>
            <img src={IconOffice} alt="IconOffice" width="26" height="26" />
            <LinkContainer
              data-testid="cmp-office-button"
              onClick={(e) =>
                handlerRedirectNewPage(
                  'https://www.microsoft.com/es-es/education/products/office',
                  e
                )
              }
              formTarget="_blank"
              type="button"
            >
              <Text>Microsoft Office 365</Text>
            </LinkContainer>
          </ListItem>
        </ul>
      </FooterColumn>
      <FooterColumn className="col-span-2 sm:col-span-1">
        <Title>Contáctanos</Title>
        <ul>
          <ListItem>
            <img src={IconPhone} alt="IconPhone" width="18" height="18" />
            <LinkContainer
              data-testid="cmp-phone-1-button"
              onClick={() => handlerRedirectNewPage('tel:013159600')}
              formTarget="_blank"
              type="button"
            >
              <Text>Lima (01) 315 9600</Text>
            </LinkContainer>
          </ListItem>
          <ListItem>
            <img src={IconPhone} alt="IconPhone" width="18" height="18" />
            <LinkContainer
              data-testid="cmp-phone-2-button"
              onClick={() => handlerRedirectNewPage('tel:080119600')}
              formTarget="_blank"
              type="button"
            >
              <Text>Provincias 0801 19 600</Text>
            </LinkContainer>
          </ListItem>
          <ListItem>
            <ChannelWhatsapp
              data-testid="cmp-whatsapp-button"
              style={{ display: 'flex' }}
              onClick={() =>
                handlerRedirectNewPage(
                  'https://api.whatsapp.com/send?phone=51960252970&text=Hola%2C%20soy%20alumno%20UTP%20y%20deseo%20hacer%20una%20consulta'
                )
              }
              formTarget="_blank"
              type="button"
            >
              <img src={IconWhatsapp} alt="whatsapp" width="24" height="24" />
              <WhatsappInfo>
                <div>Escríbenos en Whatsapp</div>
                <InfoChannel>960 252 970</InfoChannel>
              </WhatsappInfo>
            </ChannelWhatsapp>
          </ListItem>
        </ul>
      </FooterColumn>
    </FooterContainer>
    <LineSeparatorBot />
    <AllRightsReserved>
      Todos los derechos reservados - UTP + Portal 2022
    </AllRightsReserved>
  </Container>
);

export default FooterView;
